export default __webpack_public_path__ + "static/Yard-Waste-c22191321c524be26d9abdcc24d7729a.jpg";